module.exports = __webpack_public_path__ + "img/HM2012.22f7b01c.png";